import type { KnowledgeBaseUsage } from "@/services/knowledge-base.service";
import { counted, formatBytes, formatCount, formatPages, percentUsed } from "@/utils/kb-upload-rules";

interface UsageStripProps {
  usage: KnowledgeBaseUsage;
  /** On a knowledge base's page: the files its limit counts. Without it, the strip counts knowledge bases. */
  files?: number;
}

/** The plan's limits and what is used of them: "2 of 3 files", "12 MB of 50 MB", "Text this month: 42% of about 15,000 pages". */
export function UsageStrip({ usage, files }: UsageStripProps) {
  const { limits } = usage;
  const items = [
    files === undefined
      ? `${formatCount(usage.knowledge_bases)} of ${counted(limits.max_kbs, "knowledge base")}`
      : `${formatCount(files)} of ${counted(limits.max_files_per_kb, "file")}`,
    `${formatBytes(usage.storage_bytes)} of ${formatBytes(limits.max_storage_bytes)}`,
    `Text this month: ${percentUsed(usage.month_chunks, limits.max_chunks_per_month)}% of ${formatPages(limits.max_chunks_per_month)}`,
  ];
  return (
    <ul
      aria-label="Plan usage"
      className="flex flex-wrap items-center gap-x-4 gap-y-1 rounded-lg border bg-muted/30 px-4 py-2 text-sm text-muted-foreground"
    >
      <li className="font-medium text-foreground">{usage.plan === "pro" ? "Pro plan" : "Free plan"}</li>
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}
